import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import LessonPage from "@/pages/LessonPage";
import AuthGate from "@/components/AuthGate";

export const Route = createFileRoute("/learn/$slug/$stepIndex")({
  head: ({ params }) => seoHead(`/learn/${params.slug}/${params.stepIndex}`),
  component: () => (
    <AuthGate><LessonPage /></AuthGate>
  ),
});
